import {
  BarChart, Bar,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts'

function getCrossSegmentComparison() {
  return [
    { segment: 'Champions', openRate: 78, clickRate: 22, conversionRate: 15 },
    { segment: 'Loyal', openRate: 65, clickRate: 15, conversionRate: 10 },
    { segment: 'Potential', openRate: 45, clickRate: 8, conversionRate: 5 },
    { segment: 'At Risk', openRate: 25, clickRate: 3, conversionRate: 1 },
    { segment: 'Lost', openRate: 8, clickRate: 1, conversionRate: 0 }
  ]
}

export default function AdvancedSegmentsTab() {
  return (
    <div className="space-y-8">
      {/* Dynamic Segment Builder */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Dynamic Segment Builder</h2>
        <div className="space-y-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Open Rate</label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2">
                <option>Greater than 20%</option>
                <option>Greater than 40%</option>
                <option>Less than 10%</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Click Rate</label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2">
                <option>Greater than 5%</option>
                <option>Greater than 10%</option>
                <option>Less than 2%</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Last Active</label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2">
                <option>Within 7 days</option>
                <option>Within 30 days</option>
                <option>More than 30 days</option>
              </select>
            </div>
          </div>
          <button className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700">
            Apply Filters & Create Segment
          </button>
        </div>
        <div className="border-t pt-4">
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Saved Segments</h3>
          <div className="space-y-2">
            {[
              { name: 'Super Engaged Users', size: 245, openRate: 68, clickRate: 15 },
              { name: 'Recent Inactives', size: 112, openRate: 8, clickRate: 1 },
              { name: 'VIP Subscribers', size: 89, openRate: 78, clickRate: 22 },
              { name: 'At-Risk Churners', size: 156, openRate: 12, clickRate: 2 }
            ].map((segment, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-900">{segment.name}</p>
                  <p className="text-xs text-gray-500">{segment.size} subscribers • {segment.openRate}% open • {segment.clickRate}% click</p>
                </div>
                <div className="flex gap-2">
                  <button className="text-sm text-blue-600 hover:text-blue-700">Target</button>
                  <button className="text-sm text-gray-600 hover:text-gray-700">Edit</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Cross-Segment Comparison */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Cross-Segment Performance Comparison</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={getCrossSegmentComparison()}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="segment" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="openRate" fill="#10b981" name="Open Rate %" />
            <Bar dataKey="clickRate" fill="#3b82f6" name="Click Rate %" />
            <Bar dataKey="conversionRate" fill="#f59e0b" name="Conversion Rate %" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
